import { Paperclip, Download } from "lucide-react";

export default function MediaViewer({ media }) {
  if (!media?.media_data || media.media_type === "text") return null;

  const { media_type, media_data, media_filename } = media;

  if (media_type === "image") {
    return (
      <div className="rounded-md overflow-hidden border border-gold-subtle">
        <img src={media_data} alt={media_filename || ""} className="w-full" />
      </div>
    );
  }

  if (media_type === "audio") {
    return (
      <audio controls src={media_data} className="w-full" data-testid="media-viewer-audio" />
    );
  }

  if (media_type === "video") {
    return (
      <video
        controls
        src={media_data}
        className="w-full rounded-md"
        data-testid="media-viewer-video"
      />
    );
  }

  // generic file
  return (
    <a
      href={media_data}
      download={media_filename || "archivo"}
      className="glass-card rounded-md p-4 flex items-center gap-3 hover:border-gold transition"
    >
      <Paperclip className="w-5 h-5 text-gold" />
      <span className="text-gold-light flex-1 truncate">{media_filename || "Archivo"}</span>
      <Download className="w-4 h-4 text-faded" />
    </a>
  );
}
